
import { Component, Vue, Prop } from 'vue-property-decorator'
import { statusTypes } from '@/settings/online'

/**
 * @prop order              协助信息
 * @prop hasComment         是否含有评论
 * @prop isEvaluating       是否等待对方评价中
 * @prop closed             协助是否已关闭
*/
@Component({
    name: 'order-info'
})
export default class extends Vue {
    @Prop({ required: true }) private order!: any
    @Prop({ required: true }) private isEvaluating!: boolean
    @Prop({ default: false }) private closed!: boolean

    get commentTooltip() {
        if (this.isEvaluating) {
            return '已发起服务评价，请耐心等待用户反馈。'
        } else if (this.order.status.id === statusTypes.unassigned.value) {
            return '请先进行回复'
        }
        return ''
    }

    onSendEvaluation() {
        if (this.commentTooltip) {
            return
        }
        this.$confirm('正在发起服务评价，是否继续', {
            title: '发起服务评价'
        }).then(() => {
            this.$emit('appraise')
        }).catch(() => {})
    }
}
